import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'

interface SessionExpiredDialogProps {
  open: boolean
  onBackToLogin: () => void
}

export function SessionExpiredDialog({ open, onBackToLogin }: SessionExpiredDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onBackToLogin}
      disableEscapeKeyDown
      disablePortal
      hideBackdrop={false}
      // Prevent closing when clicking outside the dialog
      disableRestoreFocus
      // This is the proper way to disable backdrop click in MUI v5
      onBackdropClick={(e) => e.stopPropagation()}
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },
        // Make sure the dialog is on top of everything
        zIndex: 9999,
      }}
      data-testid="session-expired-dialog"
    >
      <DialogTitle>Session Expired</DialogTitle>
      <DialogContent>
        <DialogContentText>Your session has expired. Please log in again to continue.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onBackToLogin} color="primary" autoFocus>
          Back to Login
        </Button>
      </DialogActions>
    </Dialog>
  )
}
